function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M16.6665 16.6667C17.1085 16.6667 17.5325 16.4911 17.845 16.1785C18.1576 15.866 18.3332 15.442 18.3332 15V6.66667C18.3332 6.22464 18.1576 5.80072 17.845 5.48816C17.5325 5.17559 17.1085 5 16.6665 5H10.0832C9.80443 5.00273 9.52946 4.93551 9.28342 4.80448C9.03738 4.67346 8.82814 4.48281 8.67484 4.25L7.99984 3.25C7.84808 3.01956 7.64148 2.8304 7.39859 2.6995C7.15569 2.56859 6.88409 2.50005 6.60817 2.5H3.33317C2.89114 2.5 2.46722 2.67559 2.15466 2.98816C1.8421 3.30072 1.6665 3.72464 1.6665 4.16667V15C1.6665 15.442 1.8421 15.866 2.15466 16.1785C2.46722 16.4911 2.89114 16.6667 3.33317 16.6667H16.6665Z",
  stroke: "currentColor",
  strokeWidth: 1.45833,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgFolder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.770af8a2.svg";
export { ForwardRef as ReactComponent };